<template>
    <v-dialog v-model="showBiographyEditDialog" content-class="medium">
        <v-card class="myprofile-popup">
            <v-card-title primary-title>
                {{memberProfileConstants.ABOUT_ME_SECTION.EDIT_MY_BIOGRAPHY}}
                <i class="fas fa-times" data-qe-id="close_biography-edit_btn" @click="closeBiographyEdit()"></i>
            </v-card-title>
            <v-card-text class="my-biography">
                <v-flex class="details-view">
                    <v-flex tag="h6">{{memberProfileConstants.ABOUT_ME_SECTION.MY_BIOGRAPHY}}
                    </v-flex>
                </v-flex>
                <v-textarea v-model="biographyData" :placeholder="memberProfileConstants.DEFAULT_EDIT_TEXT.MY_BIOGRAPHY" data-qe-id="biography-edit_popup"></v-textarea>
            </v-card-text>
            <status-bar :action="saveBiographyAction"></status-bar>
            <v-card-actions>
                <v-flex text-xs-right pa-3>
                    <v-flex>
                        <v-btn flat class="primary_btn transparent" data-qe-id="cancel_biography-edit_btn" @click="closeBiographyEdit()">
                            {{appCommonConstants.CANCEL}}
                        </v-btn>
                        <v-btn flat @click="saveBiographyDetails()" data-qe-id="save_biography_btn" class="primary_btn">
                            {{appCommonConstants.DONE}}
                        </v-btn>
                    </v-flex>
                </v-flex>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import { appCommonConstants } from "../../appCommon.constants.js";
    import { mapActions, mapState } from "vuex";
    import { memberProfileConstants } from ".././memberProfile.constants.js";
    import { storeAction } from "../../../store/storeActions.constant";
    import StatusBar from "../../StatusBar/StatusBar";
    import { gaDataLayerEvent } from "@/plugins/analytics";
    import { gtmEventName } from "@/plugins/gtmAnalytics";
    
export default {
    name: "BiographyEditDialog",
    data: () => ({
        appCommonConstants,
        memberProfileConstants,
        biographyData: "",
    }),
    props: {
        memberId: {
            type: String,
            required: true,
        },
        value: {
            type: Boolean,
        },
        myBiographyData: {
            type: String,
            required: true,   
        },
    },
    components: {
        StatusBar,
    },
    created() {
        this.biographyData = this.myBiographyData;
    },
    methods: {
        ...mapActions({
            getBiography: `memberProfile/${storeAction.getBiography}`,
            saveBiography: `memberProfile/${storeAction.saveBiography}`,
        }),
        closeBiographyEdit() {
            this.showBiographyEditDialog = false;
            this.biographyData = "";
        },
        saveBiographyDetails() {
            const postBody = {
                biography: this.biographyData || " ",
                personId: this.memberId,
            };
            this.saveBiography(postBody)
            .then(() => {
                this.closeBiographyEdit();
                this.getBiography(this.memberId);
                gaDataLayerEvent(gtmEventName.C_Profile_Edit, `Biography - ${this.memberId}${this.isRedirectFromConnectPlus ? ' | Connect+ Redirect' : ''}`);
            });
        },
    },
    computed: {
        ...mapState("actionState", ["actions"]),
        showBiographyEditDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        saveBiographyAction() {
            return this.actions[storeAction.saveBiography];
        },
      isRedirectFromConnectPlus() {
        return this.$route && this.$route.query
            && this.$route.query.connectPlusRedirect && this.$route.query.connectPlusRedirect === 'true';
      },
    },
};
</script>
